import React from 'react';
import { useDrag, useDrop } from 'react-dnd';
import { HiOutlinePencil, HiOutlineTrash  } from 'react-icons/hi';

const TaskCard = ({ task, index, moveTask, columnId, columnColor }) => {
  const [{ isDragging }, drag] = useDrag({
    type: 'TASK',
    item: { id: task.id, index, columnId },
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
  });

  const [, drop] = useDrop({
    accept: 'TASK',
    hover(item, monitor) {
      if (!drag) {
        return;
      }
      const dragIndex = item.index;
      const hoverIndex = index;
      const sourceColumnId = item.columnId;
      const targetColumnId = columnId;

      if (dragIndex === hoverIndex && sourceColumnId === targetColumnId) {
        return;
      }

      moveTask(sourceColumnId, targetColumnId, dragIndex, hoverIndex, item.id);
      item.index = hoverIndex;
      item.columnId = targetColumnId;
    },
  });

  return (
    <div ref={(node) => drag(drop(node))} className={`task ${isDragging ? 'is-dragging' : ''}`}>
      <div className="task-content">
        <h3 className="task-title" style={{ backgroundColor: columnColor }}>{task.title}</h3>
        <p className="task-description">{task.description}</p>
      </div>
      <div className="task-actions">
        <button onClick={() => moveTask(columnId, 'edit', index, null, task.id)} className="edit-btn"><HiOutlinePencil /></button>
        <button onClick={() => moveTask(columnId, 'delete', index, null, task.id)} className="delete-btn"><HiOutlineTrash /></button>
      </div>
    </div>
  );
};

export default TaskCard;
